module.exports = __webpack_public_path__ + "static/media/filename (20).2bed5a06.png";